import { createQueryKey } from '@/api/utils/query-key'

export const accountQueryKey = {
  fetchUserInfo: () => createQueryKey('account', 'user-info'),
  fetchPaymentInfo: () => createQueryKey('account', 'payment-info'),
  fetchInvoiceDetails: params => createQueryKey('account', 'invoice-details', params),
  fetchCouponDetails: params => createQueryKey('account', 'coupon-details', params),
  fetchProductDetails: params => createQueryKey('account', 'product-details', params),
  fetchUserProducts: () => createQueryKey('account', 'user-products'),
  fetchTeamMembers: () => createQueryKey('account', 'team-members'),
}
